import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

function UploadPanel({ onUpload, uploading, songs, onSelectSong, onDeleteSong, saxType, onSaxTypeChange, loading }) {
  const { t } = useTranslation();
  const fileInputRef = useRef(null);
  const [dragOver, setDragOver] = useState(false);

  const handleFileSelect = (file) => {
    if (!file) return;
    const ext = file.name.toLowerCase();
    if (ext.endsWith('.xml') || ext.endsWith('.musicxml') || ext.endsWith('.mxl')) {
      onUpload(file, 'musicxml');
    } else if (file.type.startsWith('image/') || ext.endsWith('.png') || ext.endsWith('.jpg') || ext.endsWith('.jpeg') || ext.endsWith('.webp')) {
      onUpload(file, 'image');
    } else {
      alert(t('saxTutor.unsupportedFile'));
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files[0];
    handleFileSelect(file);
  };

  return (
    <div className="saxtutor-upload-panel">
      <div className="saxtutor-upload-config">
        <label>
          {t('saxTutor.saxophoneType')}:
          <select value={saxType} onChange={(e) => onSaxTypeChange(e.target.value)}>
            <option value="Soprano">{t('saxTutor.soprano')}</option>
            <option value="Alto">{t('saxTutor.alto')}</option>
            <option value="Tenor">{t('saxTutor.tenor')}</option>
            <option value="Baritone">{t('saxTutor.baritone')}</option>
          </select>
        </label>
      </div>

      <div
        className={`saxtutor-dropzone ${dragOver ? 'drag-over' : ''} ${uploading ? 'uploading' : ''}`}
        onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
        onDragLeave={() => setDragOver(false)}
        onDrop={handleDrop}
        onClick={() => !uploading && fileInputRef.current?.click()}
        role="button"
        tabIndex={0}
        aria-label={t('saxTutor.uploadSheetMusic')}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); !uploading && fileInputRef.current?.click(); } }}
      >
        {uploading ? (
          <div className="saxtutor-upload-progress">
            <div className="saxtutor-spinner" />
            <p>{t('saxTutor.analyzing')}</p>
          </div>
        ) : (
          <>
            <div className="saxtutor-upload-icon">📄🎵</div>
            <h3>{t('saxTutor.uploadSheetMusic')}</h3>
            <p>{t('saxTutor.dragDrop')}</p>
            <p className="saxtutor-upload-formats">
              {t('saxTutor.musicxmlFormat')}<br />
              {t('saxTutor.imageFormat')}
            </p>
          </>
        )}
        <input
          ref={fileInputRef}
          type="file"
          accept=".xml,.musicxml,.mxl,image/png,image/jpeg,image/webp"
          onChange={(e) => handleFileSelect(e.target.files[0])}
          style={{ display: 'none' }}
        />
      </div>

      {songs.length > 0 && (
        <div className="saxtutor-song-library">
          <h3>{t('saxTutor.yourSongs')}</h3>
          <div className="saxtutor-song-list">
            {songs.map((song) => {
              const id = song.id || song.Id;
              const title = song.title || song.Title;
              const source = song.sourceType || song.SourceType;
              return (
                <div key={id} className="saxtutor-song-item">
                  <div className="saxtutor-song-info" onClick={() => !loading && onSelectSong(id)}>
                    <span className="saxtutor-song-icon">{source === 'Image' || source === 0 ? '📷' : '📄'}</span>
                    <span className="saxtutor-song-title">{title}</span>
                  </div>
                  <button
                    className="saxtutor-song-delete"
                    onClick={(e) => { e.stopPropagation(); onDeleteSong(id); }}
                    title={t('saxTutor.delete')}
                    aria-label={`${t('saxTutor.delete')} ${title}`}
                  >
                    🗑️
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default UploadPanel;
